
<script setup lang="ts">
const config = useRuntimeConfig().public
const captcha = config.appEnv === 'production' ? config.recaptcha : (config.recaptchaTest || config.recaptcha)
</script>

<template>
  <div class="recaptcha">
    <div
      id="recaptcha"
      class="g-recaptcha"
      :data-sitekey="captcha"
      data-callback="recaptchaCallback"
      data-expired-callback="recaptchaExpired"
    />

    <slot />
  </div>
</template>

<style lang="scss" scoped>
.recaptcha {
  margin: 3.2rem 0;

  @include atM {
    display: flex;
    justify-content: space-between;
    align-items:flex-end;
    width: 100% ;
  }
}
</style>
